import { InjectionToken } from '@angular/core';
 
export type EnvironmentConfiguration = {
    [key: string]: any;
    production: boolean,
    apiConfigUri: string,
    apiConfigScopes: string[],
    fetrapiEnv: string,
    fetrapiActiveEnvironment: boolean,
    fetrapiWww: string,
    fetrapiApi: string,
    fetrapiFMEUploads: string,
    fetrapiFMEDataSets: string,
    fetrapiShareServiceClient: string,
    fetrapiLoginRedirectURL: string,
    fetrapiLoginPostLogoutRedirectUri: string,
    fetrapiWebAPIScope: string,
    fetrapiClientID: string,
    fetrapiTenantId: string,
    fetrapiAuthority: string,
};
export const ENVIRONMENT_CONFIG = new InjectionToken<EnvironmentConfiguration>(
  'Environment_Configuration',
);